export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Notification} from 'kpc';
import {bind} from 'kpc';

export default class extends Component {
    static template = template;
    
    @bind
    hideClosable() {
        Notification.info({
            title: '隐藏关闭按钮',
            content: '这条通知隐藏了关闭按钮',
            closable: false
        });
    }
}